import { useState, memo } from "react";
import { Grid, Button, CircularProgress } from "@mui/material";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import CreateSettingCourierModal from "../modals/SettingCourier/CreateSettingCourierModal";

const CreateSettingCourier = ({
  loading,
  error,
  createCourier,
  templates,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleCreateSettingCourier = async (data) => {
    try {
      await createCourier(data);
    } catch (error) {
      console.error(`Error al realizar el request: ${error}`);
    } finally {
      handleCloseModal();
    }
  };

  return (
    <>
      <Grid item md={2} xs={6}>
        <Button
          variant="outlined"
          onClick={handleOpenModal}
          disabled={loading}
          startIcon={
            loading ? (
              <CircularProgress size={20} />
            ) : (
              <GroupAddIcon fontSize="small" />
            )
          }
        >
          {loading ? "Procesando..." : "Crear Courier"}
        </Button>
      </Grid>
      <CreateSettingCourierModal
        open={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleCreateSettingCourier}
        loading={loading}
        templates={templates}
      />
    </>
  );
};

export default memo(CreateSettingCourier);
